import { LoadingButton } from '@mui/lab';
import { Button, Modal, Box } from '@mui/material';
import React from 'react';
import { DeleteModalContainer } from './HotlistModal.styles';

const DeleteModal = ({
  plateState,
  open,
  onClose,
  onDelete,
  deleteLoading,
}: any) => {
  return (
    <Modal open={open} onClose={onClose}>
      <DeleteModalContainer>
        <Box>Are you sure you want to delete {plateState} ?</Box>
        <Box display="flex" gap="12px">
          <Button
            sx={{ flexGrow: 1 }}
            variant="contained"
            size="large"
            color="primary"
            onClick={onClose}
          >
            Cancel
          </Button>
          <LoadingButton
            sx={{ flexGrow: 1 }}
            variant="contained"
            size="large"
            color="error"
            onClick={onDelete}
            loading={deleteLoading}
          >
            Delete
          </LoadingButton>
        </Box>
      </DeleteModalContainer>
    </Modal>
  );
};

export default DeleteModal;
